import type { ProjectInput } from '../domain/entities/Project.entity';

/**
 * Real project/mine data provided directly by the client (Daruosh) on
 * 2026-08-10. Location, start date, GPS coordinates, target mineral (for the
 * three exploration areas) and cover photos are confirmed as NOT YET KNOWN
 * by the client — per explicit instruction ("هیچ اطلاعاتی را حدس نزن"),
 * those fields are left `null`/empty/placeholder rather than guessed. The
 * `Project` entity (see domain/entities/Project.entity.ts) was extended
 * specifically to allow this — it used to require all of these fields.
 *
 * The smelting-plant license is intentionally NOT here — see
 * content/industrial-projects.content.ts and components/IndustrialProjects.tsx.
 */
export const projectsContent: ProjectInput[] = [
  {
    id: 'project-takashkhaneh-calcite',
    slug: 'takashkhaneh-white-calcite',
    name: 'معدن کلسیت سفید تک‌اشخانه',
    status: 'licensed',
    province: null,
    city: null,
    coordinates: null,
    minerals: ['کلسیت سفید'],
    coverImage: '/images/projects/placeholder-project-cover.svg',
    gallery: [],
    description:
      'شرکت داریوش معدن آذر دارای پروانه بهره‌برداری معدن کلسیت سفید تک‌اشخانه است. کلسیت سفید از مواد معدنی مورد استفاده در صنایع مختلف است و توسعه این معدن یکی از دارایی‌های معدنی شرکت محسوب می‌شود. هدف شرکت، توسعه اصولی این ذخیره و بررسی ظرفیت‌های ایجاد ارزش افزوده و بازار برای محصول آن است.',
    technicalSpecifications: [
      { label: 'شهرستان/استان', value: 'در دیتای فعلی ثبت نشده' },
      { label: 'سال شروع فعالیت', value: 'نامشخص' }
    ],
    companyRole: 'دارنده‌ی پروانه بهره‌برداری',
    startDate: null,
    completionDate: null,
    seo: {
      title: 'معدن کلسیت سفید تک‌اشخانه — داریوش معدن آذر',
      description: 'معدن کلسیت سفید تک‌اشخانه، دارای پروانه بهره‌برداری شرکت داریوش معدن آذر.'
    }
  },
  {
    id: 'project-baruq-exploration',
    slug: 'baruq-exploration-area',
    name: 'محدوده اکتشافی باروق',
    status: 'exploration',
    province: null,
    city: null,
    coordinates: null,
    minerals: [],
    coverImage: '/images/projects/placeholder-project-cover.svg',
    gallery: [],
    description:
      'محدوده اکتشافی باروق یکی از محدوده‌های اکتشافی شرکت داریوش معدن آذر است که در برنامه مطالعات و توسعه ذخایر معدنی مجموعه قرار دارد.',
    technicalSpecifications: [
      { label: 'شهرستان/استان', value: 'در دیتای فعلی نیاز به تعیین دقیق دارد' },
      { label: 'سال شروع', value: 'نامشخص' },
      { label: 'ماده معدنی هدف', value: 'نامشخص' }
    ],
    companyRole: 'دارنده‌ی محدوده اکتشافی',
    startDate: null,
    completionDate: null,
    seo: {
      title: 'محدوده اکتشافی باروق — داریوش معدن آذر',
      description: 'محدوده اکتشافی باروق، از پروژه‌های اکتشافی شرکت داریوش معدن آذر.'
    }
  },
  {
    id: 'project-tarkharab-exploration',
    slug: 'tarkharab-shahindezh-exploration-area',
    name: 'محدوده اکتشافی ترخراب — شاهین‌دژ',
    status: 'exploration',
    province: 'آذربایجان غربی',
    city: 'شاهین‌دژ',
    coordinates: null,
    minerals: [],
    coverImage: '/images/projects/placeholder-project-cover.svg',
    gallery: [],
    description: 'محدوده اکتشافی ترخراب در منطقه شاهین‌دژ، یکی دیگر از محدوده‌های تحت فعالیت شرکت داریوش معدن آذر است.',
    technicalSpecifications: [
      { label: 'سال شروع', value: 'نامشخص' },
      { label: 'ماده معدنی هدف', value: 'نامشخص' }
    ],
    companyRole: 'دارنده‌ی محدوده اکتشافی',
    startDate: null,
    completionDate: null,
    seo: {
      title: 'محدوده اکتشافی ترخراب — شاهین‌دژ — داریوش معدن آذر',
      description: 'محدوده اکتشافی ترخراب در شاهین‌دژ، از پروژه‌های اکتشافی شرکت داریوش معدن آذر.'
    }
  },
  {
    id: 'project-eqbal-exploration',
    slug: 'eqbal-shahindezh-exploration-area',
    name: 'محدوده اکتشافی اقبال — شاهین‌دژ',
    status: 'exploration',
    province: 'آذربایجان غربی',
    city: 'شاهین‌دژ',
    coordinates: null,
    minerals: [],
    coverImage: '/images/projects/placeholder-project-cover.svg',
    gallery: [],
    description: 'محدوده اکتشافی اقبال در منطقه شاهین‌دژ نیز در سبد پروژه‌های اکتشافی شرکت داریوش معدن آذر قرار دارد.',
    technicalSpecifications: [
      { label: 'سال شروع', value: 'نامشخص' },
      { label: 'ماده معدنی هدف', value: 'نامشخص' }
    ],
    companyRole: 'دارنده‌ی محدوده اکتشافی',
    startDate: null,
    completionDate: null,
    seo: {
      title: 'محدوده اکتشافی اقبال — شاهین‌دژ — داریوش معدن آذر',
      description: 'محدوده اکتشافی اقبال در شاهین‌دژ، از پروژه‌های اکتشافی شرکت داریوش معدن آذر.'
    }
  }
];
